import type { SupportedLocale } from 'i18n/util/locale'

export interface LanguageOption {
  locale: SupportedLocale
  /** Language name in its native language */
  nativeName: string
}

export const LANGUAGE_OPTIONS: Array<LanguageOption> = [
  { locale: 'en-AU', nativeName: 'English' },
  { locale: 'fr-FR', nativeName: 'Français' },
  { locale: 'de-DE', nativeName: 'Deutsch' },
]
